export default __webpack_public_path__ + "static/hetzner_community_6-d1bace9175541fa3c30f1091d648080c.jpg";